import type { ParametrosAvancadosModel } from "../models/parametrosAvancadosModel"

export enum ParametrosAvancadosActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    RESETAR = "RESETAR",
}

export type ParametrosAvancadosActionModel =
    | { type: ParametrosAvancadosActionsTypes.CARREGAR; payload: ParametrosAvancadosModel }
    | {
          type: ParametrosAvancadosActionsTypes.ATUALIZAR_CAMPO
          payload: { campo: keyof ParametrosAvancadosModel; valor: string | number | boolean | null }
      }
    | { type: ParametrosAvancadosActionsTypes.RESETAR }
